import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Form, Container } from 'react-bootstrap';
// import MapWrapped from '../DefaultLayout/gMaps';

class ContactUs extends Component {

    render() {
        return (

            <Container>
                <Row>
                    <Col md={12}>
                        <h2 className="h4 mt-4 text-black text-uppercase">Get in Touch with us</h2>
                        <hr />
                    </Col>
                </Row>
                <Row>
                    <Col md={7} className="mb-5">
                        <Form className="bg-white">
                            <Form.Row className="row form-group">
                                <Col md={6}>
                                    <label className="text-black" htmlFor="fname">First Name</label>
                                    <input type="text" id="fname" className="form-control" />
                                </Col>
                                <Col md={6}>
                                    <label className="text-black" htmlFor="lname">Last Name</label>
                                    <input type="text" id="lname" className="form-control" />
                                </Col>
                            </Form.Row>
                            <Form.Row className="row form-group">
                                <Col md={12}>
                                    <label className="text-black" htmlFor="email">Email</label>
                                    <input type="email" id="email" className="form-control" />
                                </Col>
                            </Form.Row>
                            <Form.Row className="row form-group">
                                <Col md={12}>
                                    <label className="text-black" htmlFor="subject">Subject</label>
                                    <input type="subject" id="subject" className="form-control" />
                                </Col>
                            </Form.Row>
                            <Form.Row className="row form-group">
                                <Col md={12}>
                                    <label className="text-black" htmlFor="message">Message</label>
                                    <textarea name="message" id="message" cols={30} rows={7} className="form-control" placeholder="Write your notes or questions here..."></textarea>
                                </Col>
                            </Form.Row>
                            <Form.Row className="row form-group">
                                <Col md={12}>
                                    <input type="button" value="Submit" className="btn btn-primary btn-md text-white" />
                                </Col>
                            </Form.Row>
                        </Form>
                    </Col>
                    <Col md={5}>
                        <div className="bg-white">
                            <Col className="mb-3 bg-white">
                                <p className="mb-4 font-weight-bold no-wrap">NEW VENTURE RENEWABLE ENERGY</p>
                                <p className="mb-4">#1648, BDA Layout, 2 nd Block, 8th Phase, JP Nagar, Bangalore</p>
                                <p className="mb-0 font-weight-bold">Phone</p>
                                <p className="mb-2"><Link to={''}>+91 6360671683</Link></p>
                                <p className="mb-2"><Link to={''}>+91 8548975492</Link></p>
                                <p className="mb-2"><Link to={''}>+91 9980358888</Link></p>
                                <p className="mb-0 font-weight-bold">Email Address</p>
                                <p className="mb-0"><Link to={'youremail@domain.com'}>youremail@domain.com</Link></p>
                            </Col>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        {/* <MapWrapped/> */}
                    </Col>
                </Row>
                <Row><br/></Row>
            </Container>
        )
    }
}

export default ContactUs;